export default "__VITE_ASSET__CLjB8iRW__"